import React from "react";
import Layout from "../layout/Layout";
import { useLocation } from "@reach/router";
import AtithyaServices from "../templates/greet-booking/components/booking/AtithyaServices";

const AtithyaBookingPage = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext;
  return (
    <Layout crumbs={crumbs} crumbLabel={"Atithya Booking"}>
      <AtithyaServices />
    </Layout>
  );
};

export default AtithyaBookingPage;
